var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { DomainService } from 'app/services/domain.service';
import { FlipRoadService } from 'app/services/flip-road.service';
import { ResolutionCenterService } from 'app/services/resolution-center.service';
var ResolutionAOEComponent = /** @class */ (function () {
    function ResolutionAOEComponent(elemRef, activityService, attrIndexService, domainService, flipRoadService, modalService, resoCenterService) {
        this.elemRef = elemRef;
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.domainService = domainService;
        this.flipRoadService = flipRoadService;
        this.modalService = modalService;
        this.resoCenterService = resoCenterService;
        this.edit = new EventEmitter();
        this.rules = [];
        this.isFlipRoadGeom = false;
        this.domainsByColumn = {};
    }
    ResolutionAOEComponent.prototype.toggleTransposeCheckAll = function () {
        var _this = this;
        this.leftCols.forEach(function (c) { return c.isTransposable = _this.transposeCheckALl; });
        this.rightCols.forEach(function (c) { return c.isTransposable = _this.transposeCheckALl; });
    };
    ResolutionAOEComponent.prototype.switchUpDown = function (direction) {
        var cols = direction === 'left' ? this.leftCols : this.rightCols;
        var fromCol = cols.find(function (c) { return c.fromTo === 'from'; });
        var toCol = cols.find(function (c) { return c.fromTo === 'to'; });
        if (!fromCol || !toCol) {
            return;
        }
        var temp = this.centerline.props[fromCol.prop];
        this.centerline.props[fromCol.prop] = this.centerline.props[toCol.prop];
        this.centerline.props[toCol.prop] = temp;
        this.resoCenterService.onEditRecord(this.centerline, fromCol);
        this.resoCenterService.onEditRecord(this.centerline, toCol);
        this.checkDensityChange(fromCol);
        this.edit.emit({
            changedCols: [fromCol, toCol]
        });
    };
    ResolutionAOEComponent.prototype.switchLeftRight = function () {
        var _this = this;
        this.leftCols.forEach(function (c) {
            if (!c.isTransposable) {
                return;
            }
            var temp = _this.centerline.props[c.prop];
            var rightCol = _this.rightCols.find(function (rc) { return rc.neutralProp === c.neutralProp; });
            if (rightCol) {
                _this.centerline.props[c.prop] = _this.centerline.props[rightCol.prop];
                _this.centerline.props[rightCol.prop] = temp;
                //
                _this.resoCenterService.onEditRecord(_this.centerline, c);
                _this.resoCenterService.onEditRecord(_this.centerline, rightCol);
            }
        });
        this.setMetricsValue();
        this.edit.emit({
            changedCols: this.leftCols.concat(this.rightCols)
        });
    };
    // flipRoad() {
    // 	this.isFlipRoad = !this.isFlipRoad;
    // 	// this.activityService.flipRoadSubject.next({
    // 	// 	// id: this.centerline.id
    // 	// });
    // 	this.onEditCell(null, true);
    // }
    ResolutionAOEComponent.prototype.onEditCell = function (changedCol, isGeomChange) {
        // onEditCell(changedCol: ResoCenterCol, isGeomChange?: boolean) {
        this.resoCenterService.onEditRecord(this.centerline, changedCol, isGeomChange);
        this.checkDensityChange(changedCol);
        this.edit.emit({
            changedCols: changedCol ? [changedCol] : []
        });
    };
    ResolutionAOEComponent.prototype.clickExcept = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    ResolutionAOEComponent.prototype.onFeedChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var layerCateCode, cols, centerlineList, separates, i, metricsColsInfo, metricsCols, metricsSeparates, layerCate, colsForDomain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetMetrics();
                        if (!this.resolverFeed) {
                            this.rightCols = [];
                            this.rules = [];
                            return [2 /*return*/];
                        }
                        layerCateCode = Object.keys(this.resolverFeed.feed)[0];
                        return [4 /*yield*/, this.resoCenterService.transformCols(this.resolverFeed.feed[layerCateCode].cols, layerCateCode)];
                    case 1:
                        cols = _a.sent();
                        return [4 /*yield*/, this.resoCenterService.transformItemList(this.resolverFeed, layerCateCode)];
                    case 2:
                        centerlineList = _a.sent();
                        this.centerline = centerlineList[0];
                        separates = this.separateColLeftRight(cols);
                        this.leftCols = separates.leftCols;
                        this.rightCols = separates.rightCols;
                        // Default: first 3 transposable checked
                        if (this.leftCols.length >= 3) {
                            for (i = 0; i < 3; i++) {
                                this.leftCols[i].isTransposable = true;
                            }
                        }
                        metricsColsInfo = this.resolverFeed.feed[layerCateCode].metrics;
                        if (!metricsColsInfo) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.resoCenterService.transformCols(metricsColsInfo, layerCateCode)];
                    case 3:
                        metricsCols = _a.sent();
                        metricsSeparates = this.separateColLeftRight(metricsCols);
                        this.metricsInfo.leftCols = metricsSeparates.leftCols;
                        this.metricsInfo.rightCols = metricsSeparates.rightCols;
                        this.setMetricsValue();
                        _a.label = 4;
                    case 4:
                        this.rules = this.resoCenterService.transformRules(this.resolverFeed.rules);
                        layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
                        colsForDomain = cols.map(function (c) {
                            return {
                                prop: c.prop,
                                standard: layerCate.standardCols.find(function (s) { return s.colName === c.standardName; })
                            };
                        });
                        this.domainsByColumn = this.domainService.getColumnDomains(colsForDomain, layerCate.code, this.centerline.props);
                        return [2 /*return*/];
                }
            });
        });
    };
    ResolutionAOEComponent.prototype.separateColLeftRight = function (cols) {
        var _this = this;
        var leftCols = [];
        var rightCols = [];
        // Separate left cols and right cols
        cols.forEach(function (c) {
            var col = {
                prop: c.prop,
                label: c.label,
                lbType: c.lbType,
                standardName: c.standardName,
                htmlTooltip: c.htmlTooltip,
                leftRight: 'l',
                //
                neutralProp: c.prop.substring(0, c.prop.length - 2),
                neutralLabel: c.label.substring(0, c.label.length - 2)
            };
            if (c.prop.endsWith('_r')) {
                col.leftRight = 'r';
                rightCols.push(col);
            }
            else {
                leftCols.push(col);
            }
            if (c.prop.includes(_this.resoCenterService.fromAddrColCore)) {
                col.fromTo = 'from';
            }
            else if (c.prop.includes(_this.resoCenterService.toAddrColCore)) {
                col.fromTo = 'to';
            }
        });
        return {
            leftCols: leftCols,
            rightCols: rightCols
        };
    };
    ResolutionAOEComponent.prototype.resetMetrics = function () {
        this.metricsInfo = {
            leftCols: [],
            rightCols: [],
            props: {}
        };
    };
    ResolutionAOEComponent.prototype.setMetricsValue = function () {
        var _this = this;
        this.metricsInfo.leftCols.forEach(function (c) {
            if (c.prop === _this.attrIndexService.addrDensityLeftColName) {
                var info = _this.resoCenterService.getRecordInfo(_this.centerline.id);
                var density = _this.resoCenterService.calcAddressDensity(_this.centerline.props, info.geomLength);
                _this.metricsInfo.props[_this.attrIndexService.addrDensityLeftColName] = density.left;
                _this.metricsInfo.props[_this.attrIndexService.addrDensityRightColName] = density.right;
            }
        });
    };
    ResolutionAOEComponent.prototype.checkDensityChange = function (changedCol) {
        if (!changedCol) {
            return;
        }
        var recordInfo = this.resoCenterService.getRecordInfo(this.centerline.id);
        switch (changedCol.prop) {
            case this.attrIndexService.fromAddrLeftColName:
            case this.attrIndexService.toAddrLeftColName:
                var densityLeft = this.resoCenterService.calcAddressDensity(this.centerline.props, recordInfo.geomLength, 'left');
                this.metricsInfo.props[this.attrIndexService.addrDensityLeftColName] = densityLeft.left;
                break;
            case this.attrIndexService.fromAddrRightColName:
            case this.attrIndexService.toAddrRightColName:
                var densityRight = this.resoCenterService.calcAddressDensity(this.centerline.props, recordInfo.geomLength, 'right');
                this.metricsInfo.props[this.attrIndexService.addrDensityRightColName] = densityRight.right;
                break;
        }
    };
    ResolutionAOEComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.resetMetrics();
        this.flipRoadSub = this.flipRoadService.flipRoadSubject.subscribe(function (data) {
            if (data && data.id && data.id !== _this.centerline.id) {
                return;
            }
            if (data.geom) {
                _this.isFlipRoadGeom = !_this.isFlipRoadGeom;
            }
            _this.onEditCell(null, true);
        });
    };
    ResolutionAOEComponent.prototype.ngOnChanges = function (changes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!changes.resolverFeed) return [3 /*break*/, 2];
                        console.log('On feed change, AOE');
                        return [4 /*yield*/, this.onFeedChange()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ResolutionAOEComponent.prototype.ngOnDestroy = function () {
        this.flipRoadSub.unsubscribe();
    };
    return ResolutionAOEComponent;
}());
export { ResolutionAOEComponent };
